<template>
  <v-tabs
    class="my-0 fill-height"
    slider-color="transparent fill-height"
    height="40"
    color="transparent"
  >
    <v-tab
      v-for="exchange in exchangesCheckHuobi"
      :key="exchange.value"
      ripple
      class="exchange-tab"
    >
      <img
        :src="'/img/' + exchange.name + '_logo.svg'"
        :alt="exchange"
        width="20"
        height="20"
      />
      {{ exchange.name }}
    </v-tab>

    <v-tab-item
      v-for="exchange in exchangesCheckHuobi"
      :key="exchange.value"
      class="fill-height"
    >
      <ApiForm :exchange="exchange.value"></ApiForm>
    </v-tab-item>
  </v-tabs>
</template>

<style scoped>
>>> .v-window {
  display: flex;
  flex-direction: column;
  height: 100%;
}
>>> .v-window__container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.theme--light.v-toolbar {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--light .v-toolbar__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
>>> .theme--light .v-tabs__item {
  color: #468aff;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .v-tabs__item img {
  margin-right: 8px;
}
>>> .theme--light .exchange-tab {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--light .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #0051dd;
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 10px 10px 0px 0px;
}
>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}

>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}
>>> .theme--dark .v-tabs__item {
  color: #e9e9e9;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #303030 !important;
}
>>> .theme--dark .exchange-tab {
  background: #454547;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
</style>

<script>
import ApiForm from "./ApiForm";
import { mapGetters } from "vuex";

export default {
  components: {
    ApiForm
  },
  data: function() {
    return {
      exchanges: [
        { name: "Binance", value: "Binance" },
        { name: "Bittrex", value: "Bittrex" },
        { name: "Huobi", value: "Huobi" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
    exchangesCheckHuobi: function() {
      return this.exchanges;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/settings/ApiTabs.vue